import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path d="M168.53 215.47l-29.86 29.86 96 96L448 128l-29.86-29.86-183.47 182.4-66.14-65.07zm236.8 189.86H106.67V106.67H320V64H106.67A42.79 42.79 0 0064 106.67v298.66A42.79 42.79 0 00106.67 448h298.66A42.79 42.79 0 00448 405.33V234.67h-42.67v170.66z" /></svg>);